<div sds-dialog-title>
    <h2 class="align-center">Enter One-time Password</h2>
  </div>
  <div sds-dialog-content class="tablet:padding-top-2 tablet:padding-bottom-2">
    <div [class.usa-form-group--error]="!!errorMessage">
      <label class="usa-label content-align-center" for="oneTimePassword">Please enter your one-time password to see the API keys
      </label><br>
      <input class="usa-input content-align-center" type="password" name="oneTimePassword" id="oneTimePassword" [(ngModel)]="oneTimePassword" 
        [class.usa-input--error]="!!errorMessage" cdkFocusInitial><br>

        <div class="content-align-center usa-error-message" style="display: block;" *ngIf="!!errorMessage">
          {{errorMessage}}
        </div>        
    </div>
  </div>
  <div class="align-center" sds-dialog-actions>
    <button class="usa-button usa-button--secondary" (click)="onSubmit()" [disabled]="!oneTimePassword?.length">
        Submit
      </button> <br>
    <button class="usa-button usa-button--unstyled send-new-code" (click)="onSendNewCode()">
      Send new code
    </button>
  </div>
  